const images = {
    delete: require("../assets/images/delete.png"),
    menu: require("../assets/images/menu.png"),
    machine: require("../assets/images/machine.png"),
    user: require("../assets/images/user.png"),
    attendance: require("../assets/images/attendance.png"),
    add: require("../assets/images/add.png"),
    edit: require("../assets/images/edit.png"),
    back: require("../assets/images/back.png"),
    qr: require("../assets/images/qr.png"),
    person: require("../assets/images/person.png"),
    dhaga: require("../assets/images/dhaga.png"),
    frame: require("../assets/images/frame.png"),
    factory: require("../assets/images/factory.png"),
    time: require("../assets/images/time.png"),
    date: require("../assets/images/date.png"),
    save: require("../assets/images/save.png"),
    close: require("../assets/images/close.png"),
    pay: require("../assets/images/pay.png"),
    inspections: require("../assets/images/inspections.png"),
    list: require("../assets/images/list.png"),
    grid: require("../assets/images/grid.png"),
    share: require("../assets/images/share.png"),
    info: require("../assets/images/info.png"),
    camera: require("../assets/images/camera.png"),
    download: require("../assets/images/download.png"),
    mobile: require("../assets/images/mobile.png"),
    install: require("../assets/images/install.png"),
};

export default images;
